import { EventObject } from '@xstate/store-react';
import { AppRoute } from '../../../enums/appRoutes';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';
import { RegOnlyResponse } from '../../../models/services/api/postQuote';
import { saveSession } from '../../../services/session/save';
import { log } from '@domgen/shared/utils/log';

/**
 * Handles registration-only response when quote is not returned.
 *
 * Navigates to confirmation and persists reg-only response data in session.
 *
 * @param context Current store context.
 * @param event Event containing registration-only response.
 * @param enqueue Store enqueue helpers used for navigation emission.
 * @returns Updated context with confirmation reg-only data.
 */
export const noQuoteRegOnly = <T extends EventObject = EventObject>(
  context: StoreContext,
  event: T & { data: RegOnlyResponse },
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  log.debug({ message: StoreEvent.NO_QUOTE_REG_ONLY, data: event.data });
  enqueue.emit.navigate({ path: AppRoute.CONFIRMATION });
  const updatedContext = {
    ...context,
    confirmation: {
      ...context.confirmation,
      regOnlyData: event.data,
    },
  };

  saveSession(updatedContext);

  return updatedContext;
};
